import DOMPurify from 'isomorphic-dompurify'
import type { Descendant, Editor } from 'slate'
import { Text, Transforms } from 'slate'
import type {
  CustomElement,
  LinkElement,
  MentionElement,
} from 'modules/community/types/custom-editor'

export const insertText = (editor: Editor, nativeEmoji: string): void => {
  const text = { text: nativeEmoji }

  Transforms.insertNodes(editor, text)
}

export const serializeHTML = (node: Descendant | { children: Descendant[] }): string => {
  if (Text.isText(node)) {
    let string = DOMPurify.sanitize(node.text)
    const textNode = node
    if (textNode.underline) {
      string = string.trim() ? `<u>${string}</u>` : ''
    }
    if (textNode.italic) {
      string = string.trim() ? `<em>${string}</em>` : ''
    }
    if (textNode.bold) {
      string = string.trim() ? `<strong>${string}</strong>` : ''
    }
    return string
  }

  const children: string = node.children.map((n: Descendant) => serializeHTML(n)).join('')

  const elementNode = node as CustomElement

  switch (elementNode.type) {
    case 'paragraph': {
      const text = children.trim()
      return text ? `<p>${text}</p>` : '<br>'
    }
    case 'link': {
      const linkNode = node as LinkElement
      return children.trim() ? `<a href="${linkNode.url}" target="_blank">${children}</a>` : ''
    }
    case 'mention': {
      const mentionNode = node as MentionElement
      return mentionNode.displayName.trim() ? `<@${mentionNode.id}:${mentionNode.displayName}>` : ''
    }
    default: {
      return children
    }
  }
}
